<template>
  <div class="paddingTopPage centre" v-if="this.$store.state.paramsOk">
    <div>
      <div>
        <div><img src="@/assets/img/logo_sant_antonio_3_200.jpg"></div>
      </div>
      <div class="bordeaux titre-home">
        {{ this.$store.state.params.titolo }}
      </div>
      <div class="font20 bold">
        ({{ this.$store.state.params.anno }})
      </div>
      <div class="menu-container font20">
        <router-link to="/annuario">
          {{ this.$store.state.params.menu.annuario }}
        </router-link>
      </div>
      <div>{{ this.$store.state.params.annee }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HomePage',
  data() {
    return {
      paramsOK: false,
    }
  },
  computed: {
//    paramsOK() { return this.$store.state.paramsLoaded },
    ...mapState(['params'])
  },
  mounted() {
    // Load the Wordpress parameters
    if ( !this.$store.state.paramsOk ) {
      this.$store.dispatch("getParams");
    }
  } 
}
</script>